import { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useTheme,
  Box,
  Flex,
  Text,
  FormControl,
} from "@chakra-ui/react";
import openFileDialog from "../../../utils/openFileDialog";
import SubmitButton from "../../buttons/SubmitButton";
import { useToastContext } from "../../toastNotificationProvider/ToastNotificationProvider";
import { useDispatch, useSelector } from "react-redux";
import {
  uploadTimetable,
  getAllTimetable,
} from "../../../store/slice/timetableSlice";
const UploadTimeTableModal = ({ isOpen, onClose }) => {
  const { addNotification } = useToastContext();
  const { extraTextLight, primaryBlue, primaryBlueLight } =
    useTheme().colors.pallete;

  const [selectedFiles, setSelectedFiles] = useState(null); // for file upload
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const dispatch = useDispatch();
  const { uploadStatus, uploadError } = useSelector(
    (state) => state.timetables
  );
 


  useEffect(() => {
    if (!isOpen) {
      setSelectedFiles(null);
    }
  }, [isOpen]);


  const handleFileUpload = async () => {
    const files = await openFileDialog();
    setSelectedFiles(files);
  };




  const handleSubmit = async () => {
    if (!selectedFiles || selectedFiles.length === 0) {
      addNotification("Please select a file to upload", "info", 5000);
      return;
    }

    setIsSubmitLoading(true);

    const formData = new FormData();
    Object.keys(selectedFiles).forEach((key) => {
      formData.append("files", selectedFiles[key]);
    });

    try {
      await dispatch(uploadTimetable(formData)).unwrap();
      addNotification("File uploaded successfully", "success", 5000);
      dispatch(getAllTimetable());

      onClose();
    } catch (error) {
      addNotification("File uploaded failed", "error", 5000);
    } finally {
      setIsSubmitLoading(false);
    }
  };

  
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"xl"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          fontWeight={500}
          fontSize={"1.2rem"}
          color={extraTextLight}
          justifyContent={"center"}
          alignContent={"center"}
        >
          Upload Time Table
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <Box mt={10} mb={10}>
              <Flex>
                <Flex
                  w={"80%"}
                  border={"1px solid #E2E8F0"}
                  marginRight={2}
                  borderRadius={"md"}
                  alignItems={"center"}
                  pl={4}
                  cursor={"pointer"}
                  overflowX="auto"
                  scrollBehavior="smooth"
                >
                  {!selectedFiles ? (
                    <Text color="#718096">Files to upload</Text>
                  ) : (
                    Object.keys(selectedFiles).map((key, index) => (
                      <Text fontSize={"0.7rem"} key={key} color="#718096">
                        {selectedFiles[key].name}
                        {index !== selectedFiles.length - 1 && ", "}
                      </Text>
                    ))
                  )}
                </Flex>
                <Button
                  w={"20%"}
                  bg={primaryBlue}
                  _hover={{ bg: primaryBlueLight }}
                  color="white"
                  fontSize={"14px"}
                  fontWeight={500}
                  py={6}
                  px={20}
                  onClick={handleFileUpload}
                >
                  Choose file
                </Button>
              </Flex>
            </Box>
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Flex w={"full"} justifyContent={"center"}>
            <SubmitButton
              isLoading={isSubmitLoading}
              text="Upload"
              backColor={primaryBlue}
              textColor="white"
              onClickHandler={handleSubmit}
              hoverColor={primaryBlueLight}
            />
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default UploadTimeTableModal;
